export enum ResidenceEnum {
  LOCAL = 'LOCAL',
  ABOARD = 'ABOARD',
}
